var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 19.0007C10.6318 18.2108 9.07983 17.7949 7.5 17.7949C5.92017 17.7949 4.36817 18.2108 3 19.0007V6.00069C4.36817 5.21078 5.92017 4.79492 7.5 4.79492C9.07983 4.79492 10.6318 5.21078 12 6.00069M12 19.0007C13.3682 18.2108 14.9202 17.7949 16.5 17.7949C18.0798 17.7949 19.6318 18.2108 21 19.0007V6.00069C19.6318 5.21078 18.0798 4.79492 16.5 4.79492C14.9202 4.79492 13.3682 5.21078 12 6.00069M12 19.0007V6.00069",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.15c245feac44b74f324626c59e440034.svg";
export { ForwardRef as ReactComponent };